//SCR-052 (S2.4.7): modal thu hồi — destructive confirm bắt buộc lý do; expectedVersion
//đi ngầm (NEVER_USER_UI); xung đột version giữ modal + input, yêu cầu tải lại, không
//tự gửi lại mutation (IRM §8.3 stale/conflict).
import { Alert, Button, Input, Modal, Typography } from "antd";
import { useState } from "react";
import { describeAdminError, isVersionConflict } from "../administration/commandErrors";

export interface RevokeModalError {
  readonly code: string;
  readonly requestId?: string | undefined;
}

export function RevokeRoleAssignmentModal({
  open,
  roleLabel,
  scopeLabel,
  periodLabel,
  submitting,
  error,
  onCancel,
  onConfirm,
  onRefreshKeepingReason,
}: {
  readonly open: boolean;
  readonly roleLabel: string;
  readonly scopeLabel: string;
  readonly periodLabel: string;
  readonly submitting: boolean;
  readonly error: RevokeModalError | null;
  readonly onCancel: () => void;
  readonly onConfirm: (reason: string) => void;
  readonly onRefreshKeepingReason: () => void;
}) {
  const [reason, setReason] = useState("");
  const canConfirm = reason.trim().length > 0 && !submitting;

  return (
    <Modal
      open={open}
      title="Thu hồi vai trò"
      okText="Xác nhận thu hồi"
      okButtonProps={{ danger: true, disabled: !canConfirm, loading: submitting }}
      cancelText="Hủy"
      onOk={() => onConfirm(reason.trim())}
      onCancel={onCancel}
      destroyOnHidden
    >
      <div className="role-assignment-revoke-form">
        <Typography.Paragraph>
          Thu hồi <strong>{roleLabel}</strong> — {scopeLabel} ({periodLabel}). Phân quyền sẽ
          chấm dứt hiệu lực ngay khi xác nhận.
        </Typography.Paragraph>
        <label htmlFor="revoke-reason">Lý do thu hồi</label>
        <Input.TextArea
          id="revoke-reason"
          aria-label="Lý do thu hồi"
          rows={3}
          maxLength={500}
          showCount
          disabled={submitting}
          value={reason}
          onChange={(event) => setReason(event.target.value)}
        />
        {error != null && (
          <Alert
            style={{ marginTop: 12 }}
            type="error"
            showIcon
            role="alert"
            message={describeAdminError(error.code)}
            description={error.requestId ? `Mã hỗ trợ: ${error.requestId}` : undefined}
            action={
              isVersionConflict(error.code) ? (
                <Button size="small" onClick={onRefreshKeepingReason}>
                  Giữ lý do, tải lại dữ liệu
                </Button>
              ) : undefined
            }
          />
        )}
      </div>
    </Modal>
  );
}
